import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import { Grid, Row, Col } from "react-flexbox-grid"
import Layout from "../components/layout"
import SEO from "../components/seo"
import FooterMenu from "../components/footer-menu/footer-menu"
import { animated, useSpring } from "react-spring"

import "./blog.sass"

const Blog = () => {
  const fade = useSpring({
    from: {
      opacity: 0,
      transform: "translate3d(0, 30px, 0)",
    },
    to: {
      opacity: 1,
      transform: "translate3d(0, 0, 0)",
    },
  })
  const data = useStaticQuery(graphql`
    query {
      allContentfulBlogPost(sort: { fields: publishedDate, order: DESC }) {
        edges {
          node {
            title
            slug
            excerpt
            publishedDate(formatString: "MMMM Do, YYYY")
            coverImage {
              title
              file {
                url
              }
            }
          }
        }
      }
    }
  `)
  return (
    <Layout>
      <SEO title="Floorplans" />
      <animated.div style={fade} id="blog">
        <h1 className="page-title">news</h1>
        <section className="all-posts">
          <Grid fixed>
            <Row start="lg">
              {data.allContentfulBlogPost.edges.map(edge => {
                return (
                  <Col md={6} lg={4} className="post-section">
                    <Link to={`/blog/${edge.node.slug}`}>
                      <img
                        src={edge.node.coverImage.file.url}
                        alt={edge.node.coverImage.title}
                      />
                      <div className="post-wrapper">
                        <h1 className="post-title">{edge.node.title}</h1>
                        <p className="post-date">{edge.node.publishedDate}</p>
                      </div>
                      <p className="post-desc">{edge.node.excerpt}</p>
                    </Link>
                  </Col>
                )
              })}
            </Row>
          </Grid>
        </section>
      </animated.div>
      <FooterMenu />
    </Layout>
  )
}

export default Blog
